import { gql } from "@apollo/client";

//Update this!
export const ALL_OFFICERS_QUERY = gql`
  query ALL_OFFICERS_QUERY($oriIds: String!) {
    allOfficers(oriIds: $oriIds) {
      id
      deptAttribute {
        id
        badge
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
          municipalityNumber
        }
        team {
          id
          name
        }
      }
      personalAttribute {
        id
        firstName
        lastName
      }
    }
  }
`;
